import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ size = 'md', className = '' }) => {
  const imgSizes = { sm: 'h-8', md: 'h-10', lg: 'h-14' };

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src="/logo-cloudhesive.png"
        alt="Cloudhesive"
        className={`${imgSizes[size]} w-auto object-contain brightness-0 invert`}
      />
    </div>
  );
};
